import type { Namespace } from '../../../types.js';

export const dates: Namespace = {
  'dates.today': 'Сегодня',
  'dates.yesterday': 'Вчера',
  'dates.tomorrow': 'Завтра',
  'dates.month.january': 'Январь',
  'dates.month.february': 'Февраль',
  // Plural sample (used by tc):
  'dates.days_ago': {
    one: '{count} день назад',
    few: '{count} дня назад',
    many: '{count} дней назад',
    other: '{count} дня назад',
    zero: 'только что',
  },
};
